exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.my-action-sheet .van-action-sheet__header[data-v-9ea7bff2] {\r\n  font-size: 13px !important;\r\n  color: #999;\n}\n.my-action-sheet .van-action-sheet__close[data-v-9ea7bff2] {\r\n  display: none !important;\n}\n.common-link[data-v-9ea7bff2] {\r\n  color: #428bca;\n}\n.common-link[data-v-9ea7bff2]:active {\r\n  color: lightskyblue;\n}\n.box-press[data-v-9ea7bff2]:active {\r\n  background: #ececec;\n}\r\n", ""]);

// exports
